import React from "react";
import backIcon from "../../assets/images/arrow-left/icon-arrow-left.svg";
import { useRouter } from "../../hooks/useRouter";
import "./index.scss";

interface Props {
  children?: React.ReactNode;
  backButton?: boolean;
  step?: boolean;
  marginBottom?: boolean;
  handleStep?: () => void;
}

const Breadcrumb: React.FC<Props> = ({
  children,
  backButton = true,
  handleStep,
  step = false,
  marginBottom = true,
}) => {
  const router = useRouter();
  const previousPage = () => {
    window.location.href = document.referrer;
  };

  return (
    <div
      className="breadcrumb-custom"
      style={marginBottom ? { marginBottom: "37px" } : {}}
    >
      <div
        className="breadcrumb-layout"
        style={backButton ? null : { justifyContent: "center" }}
      >
        {backButton && (
          <div className="left" onClick={step ? handleStep : previousPage}>
            <img src={backIcon} alt="back" style={{ width: "10%" }} loading="lazy" decoding="async" />
            <div className="back">もどる</div>
          </div>
        )}
        <div
          className={
            backButton
              ? `title-center title title-breadcrumb_show`
              : "title title-breadcrumb_show"
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
};
export default Breadcrumb;
